import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnDepartmentSelect as UICnDepartmentSelect } from './department-select';
const CnDepartmentSelect = withI18n(UICnDepartmentSelect, {
    locale,
    _noHoc: true,
});
export { CnDepartmentSelect };
